import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';

export function useAudienceAnalyticsAudiencePicker(colors: [string, string, string, string, string]) {
    const { audiences } = useSelector((state: ApplicationState) => state.audiences);
    const audienceOptions = React.useMemo(() => {
        if (!audiences) {
            return [];
        }
        return audiences.map(item => ({ value: item._id, label: `${item.title} [${item._id}]` }));
    }, [audiences]);
    const [audienceSelectOpen, setAudienceSelectOpen] = React.useState(false);
    const [audiencesToCompare, setAudiencesToCompare] = React.useState<string[]>([]);

    const audiencesConfig = React.useMemo(() => {
        const newRecord: Record<string, { title: string; color: string }> = {};
        audiencesToCompare?.forEach((audienceId, index) => {
            const audience = audiences?.find(audience => audience._id === audienceId);
            newRecord[audienceId] = {
                title: audience?.title ?? '',
                color: colors[index + 1]
            };
        });
        return newRecord;
    }, [colors, audiencesToCompare, audiences]);

    const handleAudienceSelectOpen = React.useCallback(() => {
        setAudienceSelectOpen(true);
    }, []);
    const handleAudienceSelectClose = React.useCallback(() => {
        setAudienceSelectOpen(false);
    }, []);
    const handleAudienceChangeSubmit = React.useCallback((values: string[]) => {
        setAudiencesToCompare(values);
        setAudienceSelectOpen(false);
    }, []);
    return {
        audienceOptions,
        audienceSelectOpen,
        audiencesToCompare,
        audiencesConfig,
        handleAudienceSelectOpen,
        handleAudienceSelectClose,
        handleAudienceChangeSubmit
    };
}
